<template>
<!-- http://localhost:8080/?UI=00b400&PORT=1000&SIP=1.1.1.1&MA=AA0A0A0A0A0A -->
      <div class="rm" :ref="'rm_'+index">

        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>{{section_name}}</strong></p>
              </label>
            </div>
          </div>
        </div>

        <!-- last name and room number -->
        <div class="rm-form p-15">
          <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15 make-gooder">
              <input v-model="form.last_name" id="last_name" class="input-text rounded ln" type="text" placeholder="Last Name" />
              <input v-model="form.room_number" id="room_number" class="input-text rounded rn" type="text" placeholder="Room #" />
              <button  @click="emitRegistrationMethodData()" class="btn rounded submit-ln-rn" type="button">Accept</button>
            </div>
          </div>

          <!-- email address -->
          <div v-if="registration_method.registration_method_id==3" class="row mb-15 p-rel">
            <div class="header-text">
              Visitors, please provide your information for free WiFi access:
            </div>
            <div class="spec-width">
              <div class="row mb-15">
                <input v-model="form.first_name" class="input-text rounded fn" type="text" placeholder="First Name" />
                <input v-model="form.last_name" class="input-text rounded lnspec" type="text" placeholder="Last Name" />
              </div>
              <div>
                <input v-model="form.email_address" class="input-text small-email rounded mb-15" type="text" placeholder="Email" />
                  <button @click="emitRegistrationMethodData()" class="btn rounded btn-grn" type="button" >Accept</button>
              </div>
            </div>
          </div>

          <!--HCNY (last name and audit number)-->
          <div v-if="registration_method.registration_method_id==8" class="row p-rel">
            <div class="row mb-15 make-gooder">
              <input v-model="form.audit_number" id="audit_number" class="input-text rounded ln" type="text" placeholder="Audit Number" />
              <input v-model="form.last_name" id="last_name" class="input-text rounded rn" type="text" placeholder="Last Name" />
              <button  @click="emitRegistrationMethodData()" class="btn rounded submit-ln-rn" type="button">Accept</button>
            </div>
          </div>

          <!-- access code -->
          <div v-if="registration_method.registration_method_id==4" class="row p-rel make-gooder">
            <div class="header-text">
              Please enter your WiFi code:
            </div>
            <div >
              <input v-model="access_code" class="input-text small-code rounded mb-15" type="text" placeholder="Code" />
              <span v-if="!access_code_valid" class="error-text">{{access_code_error_text}}</span>
              <div>
                <button @click="emitRegistrationMethodData()" class="btn rounded btn-grn" type="button">Accept</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div> <!-- rm -->
</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      section_name:'',
      form: {
        last_name: '',
        room_number: '',
        email_address: '',
        audit_number: ''
      },
    }
  },
  watch: {
  
  },
  mounted(){
    if(this.registration_method.registration_method_id === 2){
      this.section_name = 'Guest Room'
    }

    else if(this.registration_method.registration_method_id === 8){
      this.section_name = 'Member'
    }

    else{
      this.section_name = this.registration_method.name
    }
  },
  methods: {
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){    
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.access_code){
        this.access_code_valid = false;
        return;
      }

      if (this.registration_method.registration_method_id === 2) {
        this.registration_method.registration_method_id = 8
      }

      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
        audit_number: null
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2' || this.registration_method.registration_method_id=='8'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name.toUpperCase();
        emitted.room_number = this.form.room_number.toUpperCase();
        emitted.audit_number = this.form.audit_number.toUpperCase();
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.first_name = this.form.first_name.toUpperCase();
        emitted.last_name = this.form.last_name.toUpperCase();
        emitted.email_address = this.form.email_address.toUpperCase();
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.access_code.toUpperCase();
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style>
::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #1f1f1f;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #1f1f1f;
   opacity:  1;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #1f1f1f;
   opacity:  1;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #1f1f1f;
}
::-ms-input-placeholder { /* Microsoft Edge */
   color:    #1f1f1f;
}

::placeholder { /* Most modern browsers support this now. */
   color:    #1f1f1f;
}
</style>
